<template>
  <!-- <b-card-code :title="$t('user.mobile')"> -->
  <div>
    <b-form
        ref="form"
        :style="{ height: trHeight }"
        class="mt-0"
        @submit.prevent="repeateAgain"
    >
      <!-- :style="{ height: trHeight }" -->
      <!-- Row Loop -->
      <b-row v-for="(userPermissionUnit, index) in userPermissionUnits" :key="index" ref="row">
        <b-col xl="2" lg="2" sm="4">
          <b-form-group
              :label="$t('permissions.unit')"
              :label-for="`userPermissionUnits-unit${index}`"
              :invalid-feedback="
              invalidPermissionUnit(index)
                ? $t(`validation.${invalidPermissionUnit(index)}`,{
                    field: $t('permissions.unit'),
                  })
                : ''
            "
              :state="
              v.userPermissionUnits.$each.$iter[index].unitId.$dirty
                ? !v.userPermissionUnits.$each.$iter[index].unitId.$invalid
                : null
            "
          >
            <my-v-select
                :key="userPermissionUnit.unitId"
                :translate="false"
                v-model="userPermissionUnit.unitId"
                :concat-label="['title']"
                :searchable="true"
                :filterable="true"
                :options="(units && units.length) ? units : []"
                :multiple="false"
                :id="`userPermissionUnits-unit${index}`"
            />
<!--            <b-form-select-->
<!--                :state="-->
<!--              v.userPermissionUnits.$each.$iter[index].unitId.$dirty-->
<!--                ? !v.userPermissionUnits.$each.$iter[index].unitId.$invalid-->
<!--                : null-->
<!--            "-->
<!--                text-field="title"-->
<!--                value-field="_id"-->
<!--                :options="units"-->
<!--                :id="`userPermissionUnits-unit${index}`"-->
<!--                v-model="userPermissionUnit.unitId"-->
<!--            >-->
<!--              <b-form-select-option-->
<!--                  v-for="c in countries"-->
<!--                  :key="c.dialCode"-->
<!--                  :value="permissionUnits[index]._id"-->
<!--              >-->
<!--                <div-->
<!--                    style="background-color: red"-->
<!--                    class="d-flex justify-content-between"-->
<!--                >-->
<!--                  <span>({{ c.dialCode }})</span>-->
<!--                  <span>{{ c.title }}</span>-->
<!--                </div>-->
<!--              </b-form-select-option>-->
<!--            </b-form-select>-->
          </b-form-group>
        </b-col>
        <!-- Item Mobile -->
        <b-col xl="2" lg="3" sm="5">
          <b-form-group
              :invalid-feedback="
              invalidPermissionUnitId(index)
                ? $t(`validation.${invalidPermissionUnitId(index)}`,{
                    field: $t('permissions.unitPermissions'),
                  })
                : ''
            "
              :state="
              v.userPermissionUnits.$each.$iter[index].permissionUnitId.$dirty
                ? !v.userPermissionUnits.$each.$iter[index].permissionUnitId.$invalid
                : null
            "
              :label="$t('permissions.unitPermissions')"
              :label-for="`userPermissionUnits-unitPermissions${index}`"
          >
            <my-v-select
                :key="userPermissionUnit.permissionUnitId"
                :translate="false"
                v-model="userPermissionUnit.permissionUnitId"
                :concat-label="['title']"
                :searchable="true"
                :filterable="true"
                :options="(permissionUnits && permissionUnits.length) ? permissionUnits : []"
                :multiple="false"
                :id="`userPermissionUnits-unitPermissions${index}`"
            />
<!--            <b-form-select-->
<!--                :state="-->
<!--              v.userPermissionUnits.$each.$iter[index].permissionUnitId.$dirty-->
<!--                ? !v.userPermissionUnits.$each.$iter[index].permissionUnitId.$invalid-->
<!--                : null-->
<!--            "-->
<!--                text-field="title"-->
<!--                value-field="_id"-->
<!--                :id="`userPermissionUnits-unitPermissions${index}`"-->
<!--                :options="permissionUnits"-->
<!--                v-model="userPermissionUnit.permissionUnitId"-->
<!--            >-->
              <!--              <b-form-select-option-->
              <!--                  v-for="c in countries"-->
              <!--                  :key="c.dialCode"-->
              <!--                  :value="permissionUnits[index]._id"-->
              <!--              >-->
              <!--                <div-->
              <!--                    style="background-color: red"-->
              <!--                    class="d-flex justify-content-between"-->
              <!--                >-->
              <!--                  <span>({{ c.dialCode }})</span>-->
              <!--                  <span>{{ c.title }}</span>-->
              <!--                </div>-->
              <!--              </b-form-select-option>-->
<!--            </b-form-select>-->
          </b-form-group>
        </b-col>
        <!-- Remove and Add Button -->
        <b-col>
          <div class="action-buttons has-margin sm">
            <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="white"
                @click="removeItem(index)"
                v-if="index !== 0"
            >
              <b-icon icon="x-circle"
                      variant="danger"
                      scale="2"
              ></b-icon>
            </b-button>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="white"
                @click="repeateAgain"
                v-if="index === userPermissionUnits.length - 1"
            >
              <b-icon icon="plus-circle"
                      variant="success"
                      scale="2"
              ></b-icon>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
  <!--
    <template #code>
      {{ codeBasic }}
    </template> -->
  <!-- </b-card-code> -->
</template>

<script>
import BCardCode from "@core/components/b-card-code";
import { heightTransition } from "@/mixins/ui/transition";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  BFormSelectOption,
  BFormText,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
import Ripple from "vue-ripple-directive";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
// import { codeBasic } from "./code";

export default {
  components: {
    MyVSelect,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormText,
  },
  directives: {
    Ripple,
  },
  props: ["v"],
  data() {
    return {
      nextTodoId: 2,
    };
  },
  mixins: [ heightTransition],
  computed: {
    ...mapGetters({
      permissionUnits: "permissionUnits/permissionUnits",
      units: "units/units",
    }),
    userPermissionUnits: {
      set(userPermissionUnits) {
        this.$store.commit("permissions/SET_USER_PERMISSION_UNITS", userPermissionUnits);
      },
      get() {
        return this.$store.getters["permissions/userPermissionUnits"];
      },
    },
  },
  mounted() {
    this.initTrHeight();
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    invalidPermissionUnit(index) {
      var error = "";
      if (!this.v.userPermissionUnits.$each.$iter[index].unitId.$dirty) return error;
      if (
          !this.v.userPermissionUnits.$each.$iter[index].unitId.required
      ) {
        error = "required";
        return error;
      }
    },
    invalidPermissionUnitId(index) {
      var error = "";
      if (!this.v.userPermissionUnits.$each.$iter[index].permissionUnitId.$dirty) return error;
      if (
          !this.v.userPermissionUnits.$each.$iter[index].permissionUnitId.required
      ) {
        error = "required";
        return error;
      }
    },
    repeateAgain() {
      this.userPermissionUnits.push({
        // id: (this.nextTodoId += this.nextTodoId),
        unitId: "",
        mobile_number: "",
      });
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.userPermissionUnits.splice(index, 1);
      if (index !== 0) {
        this.trTrimHeight(this.$refs.row[0].offsetHeight);
      }else{
        this.userPermissionUnits.push({
          unitId: "",
          mobile_number: "",
        })
      }
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
  },
  // validations() {
  //   return {
  //     mobiles: {
  //       $each: {
  //         mobile_number: {
  //           required,
  //           mobileValidation: (value) => this.mobileValidation(value),
  //         },
  //       },
  //     },
  //   };
  // },
};
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
